import { render } from "./AplicacaoFinalizada.vue?vue&type=template&id=065a947c&scoped=true"
import script from "./AplicacaoFinalizada.vue?vue&type=script&lang=js"
export * from "./AplicacaoFinalizada.vue?vue&type=script&lang=js"

import "./AplicacaoFinalizada.vue?vue&type=style&index=0&id=065a947c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065a947c"]])

export default __exports__